import { GridColumnVisibilityModel } from '@mui/x-data-grid';
import { ContactDefaultCustomField } from 'src/constants/types';

export const getVisibleCustomFieldIds = (
  customFields: ContactDefaultCustomField[],
  columnVisibilityModel: GridColumnVisibilityModel,
): string[] => customFields
  .filter(field => columnVisibilityModel[field.metadataId!] === true)
  .map(field => field.metadataId!);

export const buildCustomFieldVisibilityFilter = (
  customFields: ContactDefaultCustomField[],
  columnVisibilityModel: GridColumnVisibilityModel,
  sortMetadataId?: string | null,
): {
  queryMetadataIds: string[];
  sortMetadataId?: string | null;
  sortOrder?: 'asc' | 'desc';
} => {
  const queryMetadataIds = getVisibleCustomFieldIds(customFields, columnVisibilityModel);

  if (sortMetadataId && !queryMetadataIds.includes(sortMetadataId)) {
    return {
      queryMetadataIds,
      sortMetadataId: null,
      sortOrder: undefined,
    };
  }

  return { queryMetadataIds };
};
